var ExternalLinks = require('../modules/external_links');
new ExternalLinks();



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/external_links.initializer.js